export enum PartnerType {
  FGTS = "FGTS",
  SALVCAR = "SALVCAR",
  CREFAZ = "CREFAZ",
  CREFISA = "CREFISA",
  PAN = "PAN",
  CLT = "CLT",
}

export const partnerLabels: Record<PartnerType, string> = {
  [PartnerType.FGTS]: "FGTS",
  [PartnerType.SALVCAR]: "Salvcar",
  [PartnerType.CREFAZ]: "Crefaz",
  [PartnerType.CREFISA]: "Crefisa",
  [PartnerType.PAN]: "PAN CLT",
  [PartnerType.CLT]: "Grandino CLT",
}

export const getPartnerLabel = (type: PartnerType): string =>
  partnerLabels[type] ?? type
